import { ScrollArea } from '@/components/ui/scroll-area';
import { useAppConfig } from '@/contexts/AppConfigContext';

export function PrivacyPolicyView() {
  const { config } = useAppConfig();

  return (
    <div className="flex min-h-screen items-center justify-center bg-adam-bg-dark p-4">
      <div className="w-full max-w-4xl">
        <div className="rounded-lg bg-adam-bg-secondary-dark p-8 shadow-md">
          <div className="mb-8 flex flex-col items-center justify-center">
            <img
              src={config?.logo_url || `/Gienox-Logo.png`}
              alt="Gienox Logo"
              className="mb-4 h-8 w-8"
            />
            <h1 className="text-center text-3xl font-semibold text-white">
              Privacy Policy
            </h1>
          </div>

          <ScrollArea className="h-[70vh]">
            <div className="space-y-6 pr-6 whitespace-pre-wrap text-gray-400 font-sans">
              {config?.privacy_policy || 'Privacy Policy content not found.'}
            </div>
          </ScrollArea>
        </div>
      </div>
    </div>
  );
}
